import * as React from 'react'

export default props => (
  <svg
    viewBox='0 0 50 16'
    {...props}
  >
    <g
      fill='none'
      fillRule='evenodd'
    >
      <path
        fill='#002295'
        d='M36.496.642c-.803-.296-2.06-.613-3.633-.613-4.004 0-6.824 1.98-6.848 4.817-.023 2.098 2.013 3.267 3.55 3.966 1.578.715 2.109 1.172 2.1 1.81-.009.979-1.259 1.426-2.423 1.426-1.623 0-2.484-.22-3.815-.766l-.522-.232-.569 3.268c.947.407 2.697.76 4.514.778 4.26 0 7.025-1.957 7.057-4.987.015-1.66-1.065-2.924-3.403-3.966-1.416-.675-2.284-1.126-2.275-1.81 0-.606.735-1.255 2.321-1.255a7.585 7.585 0 0 1 3.033.559l.364.168.549-3.163z'
      />
      <path
        fill='#FFF'
        d='M41.562 10.411c.335-.84 1.615-4.08 1.615-4.08-.024.038.332-.845.537-1.393l.274 1.258.938 4.215h-3.364zm4.94-9.44h-3.099c-.97 0-1.672.292-2.098 1.242L35.3 15.567h4.29l.834-2.236h5.124l.477 2.236h3.814L46.502.97z'
      />
      <path
        fill='#002295'
        d='M41.562 9.94c.335-.84 1.615-4.08 1.615-4.08-.024.038.332-.845.537-1.393l.274 1.258.938 4.215h-3.364zM43.403.5c-.97 0-1.672.292-2.098 1.242L35.3 15.096h4.29l.834-2.236h5.124l.477 2.236h3.814L46.502.5h-3.099z'
      />
      <path
        fill='#FFF'
        d='M20.523.97L18.02 15.568h4.052L24.574.971z'
      />
      <path
        fill='#002295'
        d='M18.02 15.096L20.523.5h4.051l-2.502 14.596z'
      />
      <path
        fill='#FFF'
        d='M14.683.97l-4.052 10.006-.357-2-1.468-6.76c-.246-.923-.99-1.213-1.869-1.245H.263v.235c1.643.39 3.121.976 4.42 1.704l3.565 12.657h4.29L18.973.971h-4.29z'
      />
      <path
        fill='#002295'
        d='M10.631 10.506l-.357-2.002c-.739-2.332-3.034-4.856-5.607-6.12l3.58 12.712h4.291L18.973.5h-4.29l-4.052 10.006z'
      />
      <path
        fill='#FB9905'
        d='M.263.5v.235c5.084 1.208 8.614 4.26 10.01 7.77l-1.467-6.76C8.56.823 7.816.533 6.937.5H.263z'
      />
    </g>
  </svg>
)
